import { ConfirmActionDialog } from "@/components/ConfirmActionDialog";
import { Button } from "@/components/ui/button";
import { TrashIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const DeleteRowConfirmationDialog: React.FC<{
  onConfirmDelete: () => void;
  isLoading?: boolean;
  type?: "iconOnly" | "regular";
  deleteText?: string;
}> = ({ onConfirmDelete, isLoading, type = "regular", deleteText }) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionDialog
      title={t("common.deleteEntity.title")}
      description={t("common.deleteEntity.description")}
      confirmButtonText={deleteText || t("common.deleteEntity.buttonText")}
      trigger={
        <Button variant="outline" size="sm" className="flex items-center gap-2 text-red-500">
          {type === "iconOnly" ? (
            <TrashIcon className="w-2 h-2" />
          ) : (
            <>
              {deleteText || t("common.deleteEntity.buttonText")} <TrashIcon className="w-2 h-2" />
            </>
          )}
        </Button>
      }
      onConfirm={onConfirmDelete}
      isLoading={isLoading}
    />
  );
};
